<template>
  <loader-content :ref="(ref:any) => loader = ref">
    <div class="tournament-info" v-if="state.tournament">
      <a href="#" @click.prevent="back()" class="nav-back">
        <svg-icon icon="back"/> <span>{{$t('back')}}</span>
      </a>
      <h1>{{$t('tournament_description')}}</h1>
      <TournamentCard  :item="state.tournament"  :key="state.tournament.id" class="tournament-details"></TournamentCard>
      <TournamentContent :tournament="state.tournament" class="tournament-content"/>
    </div>
  </loader-content>
</template>

<style scoped>
.nav-back {
  display: flex;
  gap: var(--margin-xs);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.5%;
  align-items: center;
  color: #FFFFFFA3;
  text-decoration: none;
  padding-bottom: var(--margin-sm);

}
.tournament-info {
  display: flex;
  flex-direction: column;
  margin: 0 var(--margin-normal);
}

.tournament-content {
  margin-top: var(--margin-normal);
}
</style>
<script lang="ts" setup>
import {reactive} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import { onMounted, ref} from "vue";
import LoaderContent from "@/components/LoaderContent.vue";
import {useRoute, useRouter} from "vue-router";
import SvgIcon from "@/components/SvgIcon.vue";
import TournamentCard from "@/components/tournaments/TournamentCard.vue";
import TournamentDTO from "@/models/TournamentDTO";
import TournamentContent from "@/components/TournamentContent.vue";

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const router = useRouter();
const route = useRoute();

const state = reactive({
  tournament: null as TournamentDTO|null
});

const back = () => {
  if (window.history.state?.back) {
    router.back()
  } else {
    router.push('/')
  }
}

onMounted(async () => {
  const id = route.params.id as unknown as number
  loader.value?.load(async () => {
    state.tournament = await api.call.tournaments.get(id)
  })
});

</script>
